import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import appConfig from '../../app-config';
import { apiSlice } from '../../api/apiSlice';
const baseUrl = appConfig.apiBaseUrl;

export const apiSliceUpload = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: baseUrl,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.accessToken;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      headers.set(
        'Content-Type',
        'multipart/form-data; boundary=----WebKitFormBoundaryb6S6x07TIkiAa3M4'
      );
      return headers;
    }
  }),
  endpoints: () => ({})
});

export const assignmentApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    exportFile: builder.mutation({
      query: (option) => ({
        url: `Assignment/${option.assignmentId}/${option.classId}/ExportFile`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    assignToSelf: builder.mutation({
      query: (option) => ({
        url: `Assignment/${option.assignmentId}/AssignToSelf`,
        method: 'POST',
        credentials: 'include'
      })
    }),
    reAssignToSelf: builder.mutation({
      query: (option) => ({
        url: `Assignment/${option.assignmentId}/ReAssignToSelf`,
        method: 'PUT',
        credentials: 'include'
      })
    }),
    unAssignFromMe: builder.mutation({
      query: (option) => ({
        url: `Assignment/${option.assignmentId}/UnassignFromMe`,
        method: 'DELETE',
        credentials: 'include'
      })
    }),
    isSelfAssigned: builder.mutation({
      query: (option) => ({
        url: `Assignment/${option.assignmentId}/IsSelfAssigned`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    getPreviewAssignmentInfo: builder.mutation({
      query: (option) => ({
        url: `Assignment/${option.assignmentId}/GetAssignmentInfo`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    getAssignmentBasic: builder.mutation({
      query: (option) => ({
        url: `Assignment/${option.assignmentId}/Basic`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    getQuestionDetails: builder.mutation({
      query: (option) => ({
        url: `Question/${option.questionNo}/Assignment/${option.Id}/DetailsByNumber?languageId=${option.languageId}`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    getResourceDoc: builder.mutation({
      query: (option) => ({
        url: `Question/GetResourceDocument/${option.documentId}`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    changeMode: builder.mutation({
      query: (option) => ({
        url: `Assignment/${option.assignmentId}/ChangeMode`,
        method: 'PUT',
        credentials: 'include',
        body: option.data
      })
    }),
    assignmentResponse: builder.mutation({
      query: (option) => ({
        url: `Assignment/${option.assignmentId}/Results/${option.studentId}`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    overrideResponse: builder.mutation({
      query: (option) => ({
        url: `Assignment/${option.assignmentId}/OverrideResponse/${option.questionIndex}/?sudentId=${option.sudentId}&option=${option.option}`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    shareToGoogleClassroom: builder.mutation({
      query: (classDetails) => ({
        url: 'Assignment/ShareToGoogleClassroom',
        method: 'POST',
        body: classDetails
      })
    }),
    saveAssignmentMethod: builder.mutation({
      query: (assignmentMethodData) => ({
        url: 'Assignment/SaveAssignmentMethod',
        method: 'POST',
        body: assignmentMethodData
      })
    }),
    getAssignment: builder.query({
      query: (assignmentRequestModel) => ({
        url: 'Assignment/GetAssignment',
        method: 'POST',
        body: { ...assignmentRequestModel }
      })
    }),
    getAssignmentCrGrading: builder.query({
      query: (assignmentRequestModel) => ({
        url: 'Assignment/GetAssignmentCrGrading',
        method: 'POST',
        body: { ...assignmentRequestModel }
      })
    }),
    updateCrAnswer: builder.mutation({
      query: (updateCrAnswerModel) => ({
        url: 'Assignment/ScoreCrAnswer',
        method: 'POST',
        body: { ...updateCrAnswerModel }
      })
    }),
    getStudentFile: builder.mutation({
      query: (studentFileRequest) => ({
        url: 'Assignment/GetStudentFile',
        method: 'POST',
        body: { ...studentFileRequest },
        responseHandler: 'text'
      })
    }),
    unassignStudents: builder.mutation({
      query: (unassignStudentRequest) => ({
        url: 'Assignment/UnassignStudents',
        method: 'POST',
        body: { ...unassignStudentRequest }
      })
    }),
    pushGrades: builder.mutation({
      query: (pushGradesRequest) => ({
        url: 'Assignment/PushGrades',
        method: 'POST',
        body: { ...pushGradesRequest }
      })
    }),
    setAssignmentToReview: builder.mutation({
      query: (reviewRequest) => ({
        url: 'Assignment/SetAssignmentToReview',
        method: 'POST',
        body: { ...reviewRequest }
      })
    }),
    getBasicAssignmentDetails: builder.query({
      query: (assignmentId) => ({
        url: `Assignment/getBasicAssignmentDetails/${assignmentId}`,
        method: 'GET'
      })
    }),
    getAssignmentStudents: builder.query({
      query: (assignmentId) => ({
        url: `Assignment/assignmentStudents/${assignmentId}`,
        method: 'GET'
      })
    }),
    offlineUPloadOptions: builder.query({
      query: () => ({
        url: 'Assignment/OfflineUploadOptions',
        method: 'GET'
      })
    }),
    getAssignmentSettingsDetails: builder.query({
      query: (assignmentId) => ({
        url: `Assignment/${assignmentId}/AssignmentSettings`,
        method: 'GET'
      })
    }),
    getHtmlContent: builder.mutation({
      query: (option) => ({
        url: 'Question/GetHtmlContent',
        method: 'GET',
        params: { filePath: option.filePath }
      })
    }),
    getPublicAssignmentNodes: builder.mutation({
      query: (option) => ({
        url: 'Assignment/GetPublicAssignmentNodes',
        method: 'GET',
        params: { node: option.node }
      })
    }),
    setImportPublicAssignments: builder.mutation({
      query: (option) => ({
        url: 'Assignment/ImportPublicAssignments',
        method: 'POST',
        body: option.publicAssignmentIds
      })
    }),
    RenameAssignment: builder.mutation({
      query: (option) => ({
        url: `Assignment/${option.assignmentId}/RenameAssignment?assignmentName=${option.assignmentName}`,
        method: 'PUT',
        credentials: 'include'
      })
    }),
    UpdateTeacherNote: builder.mutation({
      query: (option) => ({
        url: `Assignment/${option.assignmentId}/UpdateNote?assignmentNote=${option.assignmentNote}`,
        method: 'PUT',
        credentials: 'include'
      })
    }),
    ReclassifyCourse: builder.mutation({
      query: (option) => ({
        url: `Assignment/${option.assignmentId}/ReClassify?courseId=${option.courseId}`,
        method: 'POST',
        credentials: 'include'
      })
    }),
    SetMcStyle: builder.mutation({
      query: (option) => ({
        url: `Assignment/${option.assignmentId}/UpdateMcStyle?mcStyle=${option.mcStyle}`,
        method: 'PUT',
        credentials: 'include'
      })
    }),
    removeQuestion: builder.mutation({
      query: (option) => ({
        url: `Assignment/${option.assignmentId}/RemoveQuestion/${option.questionNo}`,
        method: 'DELETE'
      })
    }),
    reorderQuestion: builder.mutation({
      query: (option) => ({
        url: `Assignment/${option.assignmentId}/ReorderQuestion`,
        method: 'PUT'
      })
    }),
    moveQuestion: builder.mutation({
      query: (option) => ({
        url: `Assignment/${option.assignmentId}/MoveQuestion`,
        method: 'PUT',
        params: {
          currentPosition: option.currentPosition,
          newPosition: option.newPosition
        }
      })
    }),
    createAssignment: builder.mutation({
      query: (option) => ({
        url: 'Assignment/Create',
        method: 'POST',
        body: { ...option }
      })
    }),
    getAnswerHistory: builder.mutation({
      query: (option) => ({
        url: `Assignment/${option.assignmentId}/AnswerHistory`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    getAssignmentProperties: builder.mutation({
      query: (options) => ({
        url: `Assignment/${options.assignmentId}/assignmentproperties`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    getQuestionProperties: builder.mutation({
      query: (options) => ({
        url: `Question/${options.questionId}/questionproperties?assignmentId=${options.assignmentId}&courseId=${options.courseId}`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    getAllDropdownAssignments: builder.mutation({
      query: () => ({
        url: 'Assignment/GetAllForDropdown',
        method: 'GET',
        credentials: 'include'
      })
    }),
    getCastleResource: builder.mutation({
      query: (options) => ({
        url: `Assignment/${options.assignmentId}/Question/${options.questionId}/CastleResources?courseId=${options.courseId}`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    updateDocument: builder.mutation({
      query: (options) => ({
        url: `Assignment/${options.assignmentId}/Document/${options.documentId}/QuestionDocument?questionIds=${options.questionIds}&label=${options.displayText}`,
        method: 'PUT',
        credentials: 'include'
      })
    }),
    removeDocument: builder.mutation({
      query: (options) => ({
        url: `Assignment/${options.assignmentId}/Document/${options.documentId}`,
        method: 'DELETE',
        credentials: 'include'
      })
    }),
    moveDocument:builder.mutation({
      query: (options) => ({
        url: `Assignment/${options.assignmentId}/Document/${options.documentId}/MoveDocument?newPosition=${options.newPosition}`,
        method: 'PUT',
        credentials: 'include'
      })
    }),
    getAssignmentQuestionIdsByStandard: builder.mutation({
      query: (options) => ({
        url: `Assignment/${options.assignmentId}/QuestionIdsByStandard?standardNumber=${options.standardNumber}`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    getPublicAssignmentQuestionIdsByStandard: builder.mutation({
      query: (options) => ({
        url: `PublicAssignment/${options.assignmentId}/QuestionIdsByStandard?standardNumber=${options.standardNumber}`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    getPublicQuestionDetailsById: builder.mutation({
      query: (options) => ({
        url: `PublicAssignment/${options.assignmentId}/Question/${options.questionId}/DetailsById`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    createFolder: builder.mutation({
      query: (options) => ({
        url: 'Folder/Create',
        method: 'POST',
        credentials: 'include',
        body: {...options}
      })
    }),
    renameFolder: builder.mutation({
      query: (options) => ({
        url: `Folder/${options.folderId}/Rename?name=${options.folderName}`,
        method: 'PUT',
        credentials: 'include',
      })
    }),
    deleteFolder: builder.mutation({
      query: (options) => ({
        url: `Folder/${options.folderId}/Delete`,
        method: 'DELETE',
        credentials: 'include',
      })
    }),
    updateAssignmentLesson: builder.mutation({
      query: (options) => ({
        url: `Assignment/${options.assignmentId}/Lesson?lessonId=${options.lessonId}`,
        method: 'PUT',
        credentials: 'include'
      })
    }),
    getAllUserAssignments: builder.mutation({
      query: (options) => ({
        url: `Assignment/Course/${options.courseId}/Folder/${options.folderId}/${options.skip}/${options.take}`,
        method: 'POST',
        credentials: 'include',
        body: options.qTypes
      })
    }),
    AddRandomMathSkillQuestions: builder.mutation({
      query: (options) => (
        {
          url: `Assignment/${options.assignmentId}/RandomMathSkillQuestions`,
          method: 'POST',
          credentials: 'include',
          params: {...options.params}
        }
      )
    }),
    AddMathSkillQuestions: builder.mutation({
      query: (options) => ({
        url: `Assignment/${options.assignmentId}/MathSkillQuestions?courseId=${options.courseId}`,
        method: 'POST',
        body: options.questionIds
      })
    }),
    hasRetake: builder.mutation({
      query: (assignmentId) => ({
        url: `Assignment/${assignmentId}/HasRetake`,
        method: 'GET'
      })
    }),
    getAssignmentSettings: builder.query({
      query: () => ({
        url: 'Assignment/GetAssignmentSettings',
        method: 'GET'
      })
    }),
    getTeacherAssignments: builder.mutation({
      query: (options) => ({
        url: `Assignment/TeacherAssignments/${options.skip}/${options.take}`,
        method: 'PUT',
        credentials: 'include',
        body: {...options.filters}
      })
    }),
    getClassAssignments: builder.mutation({
      query: (params) => ({
        url: `Assignment/ClassAssignments?${params}`,
        method: 'GET'
      })
    })
  })
});

export const assignmentApiUpload = apiSliceUpload.injectEndpoints({
  endpoints: (builder) => ({
    uploadOflineCsv: builder.mutation({
      query: (option) => ({
        url: `Assignment/${option.assignmentId}/UploadOfflineCsv?offlineFormat=${option.offlineFormat}&blankCode=${option.blankCode}&alertCodes=${option.alertCodes}`,
        method: 'POST',
        body: option.file
      })
    })
  })
});

export const {
  useExportFileMutation,
  useAssignToSelfMutation,
  useReAssignToSelfMutation,
  useUnAssignFromMeMutation,
  useIsSelfAssignedMutation,
  useGetPreviewAssignmentInfoMutation,
  useGetAssignmentBasicMutation,
  useGetQuestionDetailsMutation,
  useChangeModeMutation,
  useGetResourceDocMutation,
  useAssignmentResponseMutation,
  useOverrideResponseMutation,
  useShareToGoogleClassroomMutation,
  useSaveAssignmentMethodMutation,
  useGetAssignmentCrGradingQuery,
  useUpdateCrAnswerMutation,
  useGetStudentFileMutation,
  useLazyGetAssignmentQuery,
  useUnassignStudentsMutation,
  usePushGradesMutation,
  useSetAssignmentToReviewMutation,
  useLazyGetBasicAssignmentDetailsQuery,
  useLazyGetAssignmentStudentsQuery,
  useLazyOfflineUPloadOptionsQuery,
  useLazyGetAssignmentSettingsDetailsQuery,
  useGetHtmlContentMutation,
  useGetPublicAssignmentNodesMutation,
  useSetImportPublicAssignmentsMutation,
  useCreateAssignmentMutation,
  useRenameAssignmentMutation,
  useUpdateTeacherNoteMutation,
  useReclassifyCourseMutation,
  useSetMcStyleMutation,
  useRemoveQuestionMutation,
  useReorderQuestionMutation,
  useMoveQuestionMutation,
  useGetAnswerHistoryMutation,
  useGetAssignmentPropertiesMutation,
  useGetQuestionPropertiesMutation,
  useGetAllDropdownAssignmentsMutation,
  useGetCastleResourceMutation,
  useUpdateDocumentMutation,
  useRemoveDocumentMutation,
  useMoveDocumentMutation,
  useGetAssignmentQuestionIdsByStandardMutation,
  useGetPublicAssignmentQuestionIdsByStandardMutation,
  useGetPublicQuestionDetailsByIdMutation,
  useCreateFolderMutation,
  useRenameFolderMutation,
  useDeleteFolderMutation,
  useUpdateAssignmentLessonMutation,
  useGetAllUserAssignmentsMutation,
  useAddRandomMathSkillQuestionsMutation,
  useAddMathSkillQuestionsMutation,
  useHasRetakeMutation,
  useGetAssignmentSettingsQuery,
  useGetTeacherAssignmentsMutation,
  useGetClassAssignmentsMutation
} = assignmentApi;

export const { useUploadOflineCsvMutation } = assignmentApiUpload;
